export default __webpack_public_path__ + "static/media/250.fcce3997.png";